"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = truncate;
exports.fixedNumberOfWords = exports.fixedNumberOfCharacters = exports.fixedLength = void 0;

var _FixedLengthTruncator = _interopRequireDefault(require("./FixedLengthTruncator"));

var _FixedNumberOfCharactersTruncator = _interopRequireDefault(require("./FixedNumberOfCharactersTruncator"));

var _FixedNumberOfWordsTruncator = _interopRequireDefault(require("./FixedNumberOfWordsTruncator"));

var _TruncateFrom = _interopRequireDefault(require("./TruncateFrom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Truncate the string
 * @param input The string to be truncated
 * @param length The length to truncate to
 * @param truncationString The string used to truncate with, defaults to '…'. Null will use default
 * @param truncator The truncator to use
 * @param from - The end to be truncated
 */
function truncate(input, length, truncationString) {
  var truncator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : fixedLength;
  var from = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _TruncateFrom["default"].End;
  if (truncationString == null) truncationString = "…";
  return truncator.truncate(input, length, truncationString, from);
}
/**
 * Fixed length truncator
 */


var fixedLength = new _FixedLengthTruncator["default"]();
/**
 * Fixed number of characters truncator
 */

exports.fixedLength = fixedLength;
var fixedNumberOfCharacters = new _FixedNumberOfCharactersTruncator["default"]();
/**
 * Fixed number of words truncator
 */

exports.fixedNumberOfCharacters = fixedNumberOfCharacters;
var fixedNumberOfWords = new _FixedNumberOfWordsTruncator["default"]();
exports.fixedNumberOfWords = fixedNumberOfWords;